var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab-item-box",class:{ disabled: _vm.disabled }},_vm._l((_vm.items),function(item,index){return _c('div',{key:index,staticClass:"tab-item hand",class:{ 'tab-active': _vm.current===index },on:{"click":function($event){return _vm.handleClickItem(item, index)}}},[_vm._v(_vm._s(item.label))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }